export default __webpack_public_path__ + "static/media/search.dcfe3468.svg";